import { api } from '@forbiz/web-kit'
import type { InvoiceDetail, InvoiceListResponse, InvoiceLineType, InvoiceStatus } from '@forbiz/contracts'

/**
 * 기업 청구 조회 API 클라이언트 (BIZ-16). 조회 전용 — 기업 관리자만.
 * 서버가 자기 기업 청구만 준다(BIZ-15). 상태 변경은 운영자 몫이라 없다.
 */
export const invoicesApi = {
  list: () => api.get<InvoiceListResponse>('/api/invoices'),
  detail: (id: number) => api.get<{ invoice: InvoiceDetail }>(`/api/invoices/${id}`),
}

export const INVOICE_STATUS_LABEL: Record<InvoiceStatus, string> = {
  DRAFT: '작성 중',
  REVIEWED: '검토 중',
  CONFIRMED: '확정',
  SENT: '발송됨',
  AWAITING_PAYMENT: '입금 대기',
  PAID: '완납',
  PARTIALLY_PAID: '부분 납부',
  OVERDUE: '연체',
  VOID: '무효',
}

export const LINE_TYPE_LABEL: Record<InvoiceLineType, string> = {
  ORDER: '주문',
  CANCELLATION_FEE: '취소 비용',
  PRIOR_PERIOD_ADJUSTMENT: '전월 조정',
  POINT_REDEEM: '포인트 사용',
  DISCOUNT: '할인',
  ETC: '기타',
}
